module.exports = __webpack_public_path__ + "img/img05.83e84339.png";